/* eslint-disable prettier/prettier */
import { PagingResultsViewModel, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class CargasSolicitudesPcfExItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: CargasSolicitudesPcfExItemViewModel[];
}

export class CargasSolicitudesPcfExItemViewModel {
    public Id: number;
    public IdPuntoInspeccion: number;
    public Descripcion: string;
    public Anno: string;
    public NumeroSolicitudes: string;
    public NumeroSemana: string;
  
}

export class CargasSolicitudesPcfExViewModel {
    constructor() { }

    public Id: number;
    public IdPuntoInspeccion: number;
    public Descripcion: string;
    public Anno: string;
    public NumeroSolicitudes: string;
    public NumeroSemana: string;
}

export class FilterSearchingCargasSolicitudesPcfExViewModel extends FilterSearchingBaseViewModel {
   
    public IdPuntoInspeccion: number | null = null;
    public Descripcion = '';
    public IdAnno: number | null = null;
    public IdNumeroSemana: number | null = null;
}

